import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment-timezone'
import { FilterTable } from 'camino-react'

import LoadingSpinner from 'Components/LoadingSpinner'

class ProblemTable extends React.Component {
  constructor (props) {
    super(props)

    this.collectCreatorNames = this.collectCreatorNames.bind(this)
    this.buildProblems = this.buildProblems.bind(this)
    this.state = {
      loading: false,
      creators: [],
      data: props.data
    }
  }

  componentDidMount () {
    this.collectCreatorNames()
  }

  collectCreatorNames () {
    const { data } = this.state
    this.setState({ loading: true })

    axios.get('/api/users', {
      params: { user_ids: _.uniq(_.map(data, problem => (problem.creator_id))) }
    })
      .then((response) => {
        this.setState({ loading: false })
        const creators = _.uniq(_.map(response.data, ({ id, name }) => ({ id, name })))

        this.setState({ creators })
      })
  }

  buildProblems () {
    const { data, creators } = this.state

    return (_.map(data, (problem) => {
      const creator = _.find(creators, ({ id }) => (problem.creator_id === id))

      return Object.assign({}, problem, creator && { creator_name: creator.name })
    }))
  }

  render () {
    const { loading } = this.state
    const { filterTabs } = this.props
    const problemsData = this.buildProblems()

    const columns = [
      {
        text: 'ID',
        accessor: 'id',
        maxWidth: '100',
        Cell: row => (
          <a href={`/problems/${row.value}`} target="_blank" rel="noopener noreferrer" className="link link-primary">
            {`#${row.value}`}
          </a>
        )
      },
      { text: 'Issue', accessor: 'issue' },
      {
        text: 'Problem Manager',
        accessor: 'problem_manager_name'
      },
      {
        text: 'Status',
        accessor: 'status',
        Cell: row => (
          <span className={`pill ${row.value === 'Open' ? 'pill--red' : 'pill--green'}`}>
            {row.value}
          </span>
        )
      },
      { text: 'Priority', accessor: 'priority' },
      { text: 'Category', accessor: 'category' },
      { text: 'Created', accessor: 'created_at', Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA')) }
    ]

    return (
      <FilterTable
        columns={columns}
        data={problemsData}
        tabs={filterTabs}
        defaultTabIndex={1}
        localStoragePrefix="ProblemTable"
      />
    )
  }
}

export default ProblemTable
